import { useEffect } from "react";
import { CheckCircle2 } from "lucide-react";
import { CLINIC } from "@/lib/api";

const values = [
  { title: "Ethical Dentistry", text: "Only treatments you truly need — never over-prescribed, always transparent." },
  { title: "Modern Technology", text: "Digital X-rays, rotary endodontics, laser tools and CAD/CAM crowns." },
  { title: "Warm Hospitality", text: "Chai on arrival, spa-like ambience and same-day follow-ups on WhatsApp." },
  { title: "Family Focus", text: "From toddlers to grandparents — one clinic your whole family can trust." },
];

export default function About() {
  useEffect(() => { document.title = "About — Manasvi Dental Clinic, Kota"; }, []);
  return (
    <div className="anim-fade-up">
      <section className="max-w-7xl mx-auto px-6 lg:px-10 pt-16 pb-12">
        <span className="text-xs uppercase tracking-[0.25em] text-primary">About Us</span>
        <h1 className="font-serif text-5xl sm:text-6xl tracking-tight mt-3 max-w-3xl">A different kind of dental experience.</h1>
        <p className="mt-6 text-lg text-muted-foreground max-w-2xl">Founded by Dr. Deepika Charan, Manasvi Dental Clinic combines evidence-based dentistry with warm, personalised care — right in the heart of Shrinath Puram, Kota.</p>
      </section>

      <section className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-12 py-12">
        <div className="lg:col-span-7">
          <div className="rounded-[2rem] overflow-hidden aspect-[5/3]">
            <img src="https://images.pexels.com/photos/6812507/pexels-photo-6812507.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" className="w-full h-full object-cover" alt="Manasvi Dental Clinic Interior" />
          </div>
        </div>
        <div className="lg:col-span-5">
          <h2 className="font-serif text-4xl">Our Story</h2>
          <p className="mt-4 text-foreground/85 leading-relaxed">Every patient who walks through our doors is more than a chart. We built Manasvi Dental Clinic with a simple belief — dentistry can be gentle, honest and genuinely enjoyable.</p>
          <p className="mt-4 text-muted-foreground leading-relaxed">From single-sitting root canals to full smile makeovers, our team blends craft with the finest global materials to deliver results that last.</p>
        </div>
      </section>

      <section className="bg-muted/40 py-20">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <h2 className="font-serif text-4xl mb-10">Our Core Values</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {values.map((v, i) => (
              <div key={i} className="bg-card border border-border rounded-2xl p-6" data-testid={`about-value-${i}`}>
                <CheckCircle2 className="w-6 h-6 text-primary mb-4" />
                <div className="font-serif text-xl mb-2">{v.title}</div>
                <p className="text-sm text-muted-foreground">{v.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 lg:px-10 py-20 grid lg:grid-cols-2 gap-10 items-center">
        <div>
          <h2 className="font-serif text-4xl">Visit Us in Kota</h2>
          <p className="mt-4 text-muted-foreground max-w-md">{CLINIC.address}</p>
          <p className="mt-2 text-muted-foreground">{CLINIC.hours}</p>
        </div>
        <div className="rounded-2xl overflow-hidden border border-border aspect-video">
          <iframe src={CLINIC.mapSrc} title="Clinic location" className="w-full h-full" loading="lazy" />
        </div>
      </section>
    </div>
  );
}
